import React from 'react'
import { Modal, Form, Col, Row, Button } from 'react-bootstrap'
import { createModal, ModalResolveType, useModalAction } from '@src/lib/modal-manager'
import { useForm } from '@src/lib/react-hook-form'
import z from 'zod'
import { CarBrandDto } from '@src/domain/repositories/setting.repo'

interface EditCarBrandProps {
  dtoUuid?: string;
  itemDto?: CarBrandDto;
}

const initState: CarBrandDto = {
  code: '',
  description: '',
  status: '1'
}

export function EditCarBrandModalWrapper(props: EditCarBrandProps) {
  const { resolve, remove, hide } = useModalAction()
  const { dtoUuid, itemDto } = props
  
  const { register, handleSubmit, formState: { errors } } = useForm<CarBrandDto>({
    reValidateMode: 'onSubmit',
    defaultValues: {...initState, ...itemDto},
    rules: z.object({
      code: z.string().min(1, { message: '請選擇車種' }),
      description: z.string().optional(),
      status: z.string().min(1, {message: '請選擇狀態'})
    })
  })

  const handleClose = () => {
    resolve(ModalResolveType.CLOSED)
    hide()
    remove()
  }

  const handleCancel = () => {
    resolve(ModalResolveType.CANCEL)
    hide()
    remove()
  }

  const handleOnSubmit = (formDto: CarBrandDto) => {
    resolve(ModalResolveType.OK, formDto)
    hide()
    remove()
  }

  return (
    <Modal size='lg' show onHide={handleClose} centered>
      <Form onSubmit={handleSubmit(handleOnSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>{`${dtoUuid ? '編輯' : '新增'}品牌`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm='2'>
              品牌名稱
            </Form.Label>
            <Col sm='10'>
              <Form.Control type='text' {...register('code')} placeholder='Ex: Toyota' />
            </Col>
            {errors.code && <Form.Text className="text-danger">{errors.code.message}</Form.Text>}
          </Form.Group>
          <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm='2'>
              狀態
            </Form.Label>
            <Col sm='10'>
              <Form.Select {...register('status')}>
                <option value='1'>啟用</option>
                <option value='0'>停用</option>
              </Form.Select>
            </Col>
            {errors.status && <Form.Text className='text-danger'>{errors.status.message}</Form.Text>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCancel} variant='light'>
            取消
          </Button>
          <Button type='submit'>
            確認
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const EditCarBrandModal = createModal(EditCarBrandModalWrapper)
